import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'

const OtherStoryExcerpt = ({ className, text }) => (
  <Typography variant="body1" classes={{ root: className }} gutterBottom>
    {text}
  </Typography>
)

OtherStoryExcerpt.propTypes = {
  className: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
}

export default OtherStoryExcerpt



// WEBPACK FOOTER //
// ./src/components/Storiespage/OtherStoryExcerpt.js